const featureFlags = {
  REGISTER_COMPLETION_ENABLED: process.env.VUE_APP_REGISTER_COMPLETION === 'true'
};

export { featureFlags };
